// extracted by mini-css-extract-plugin
export default {"container":"Loans_container__BoDvs","row":"Loans_row__9xsjD","btn":"Loans_btn__8pSYY"};